import { render, staticRenderFns } from "./AdminTagDeleteConfirmation.vue?vue&type=template&id=a7590224"
import script from "./AdminTagDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./AdminTagDeleteConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports